// ===========================================
// APPLICATION ENTRY POINT
// ===========================================

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { isAdminDomain } from './utils/domain';

// Set document direction for RTL support
const setDocumentDirection = () => {
  const lang = localStorage.getItem('i18nextLng') || 'en';
  document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
};

setDocumentDirection();

/**
 * Retire les balises SEO injectées côté serveur (frontend/server) avant que
 * React ne monte. Sans cela, React Helmet ajouterait ses propres balises à
 * côté de celles du serveur et chaque page exposerait deux title, deux
 * description et deux canonical après hydratation.
 *
 * Le contenu de #root, lui, est remplacé automatiquement par createRoot.
 */
const removeServerRenderedSeoTags = () => {
  document.querySelectorAll('[data-seo-ssr]').forEach((node) => node.remove());
};

removeServerRenderedSeoTags();

// Log app mode in development
if (import.meta.env.DEV) {
  // console.log(`[TunisTravels] Running in ${isAdminDomain() ? 'ADMIN' : 'PUBLIC'} mode`);
}

import ErrorBoundary from './components/ErrorBoundary';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
